import { mapStyles, markerSvg } from 'JBSrc/map-styles';

document.addEventListener('DOMContentLoaded', () => {
	const mapEl = document.querySelector('.map');

	if (mapEl === null) {
		return;
	}

	if (!mapEl.dataset.lat || !mapEl.dataset.lng) return;

	const loc = {
		lat: parseFloat(mapEl.dataset.lat),
		lng: parseFloat(mapEl.dataset.lng)
	};

	// eslint-disable-next-line
	const map = new google.maps.Map(mapEl, {
		center: { lat: loc.lat, lng: loc.lng },
		zoom: 8,
		mapTypeId: google.maps.MapTypeId.ROADMAP,
		backgroundColor: '#ffffff',
		zoomControl: false,
		mapTypeControl: false,
		streetViewControl: false,
		fullscreenControl: false,
		styles: mapStyles
	});

	const placeMarker = (location, address) => {
		const marker = new google.maps.Marker({
			position: location,
			map: map,
			icon: {
				url:
					'data:image/svg+xml;charset=UTF-8;base64,' +
					btoa(markerSvg),
				scaledSize: new google.maps.Size(48, 70)
			}
		});

		const infoWindow = new google.maps.InfoWindow({
			content: address,
			disableAutoPan: true
		});

		/*marker.addListener('click', function() {
			infoWindow.open(map, marker);
		});*/

		map.setZoom(16);
	};

	placeMarker(loc, mapEl.dataset.address);
});
